import axios from "axios";
import { translateApiError } from "./i18n";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/v1`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const d = error.response?.data?.detail;
    if (error.response?.status === 402 && d && typeof d === "object" && d.code) {
      window.dispatchEvent(new CustomEvent("bp:upgrade", { detail: d }));
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return translateApiError("Something went wrong. Please try again.");
  if (typeof detail === "string") return translateApiError(detail);
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? translateApiError(e.msg) : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return translateApiError(detail.msg);
  return String(detail);
}

export function formatMoney(amount) {
  return `${Number(amount || 0).toLocaleString("fr-FR").replace(/\u202f|\u00a0/g, " ")} F`; // i18n-ok: money stays "38 700 F" in both languages
}
